<ng-container *transloco="let t; read: 'user'">
<drdp-dashboard-search [displayDropdowns]="displayDropdowns" [requiredFields]="requiredFields"
  [title]="t('stateDashboard.export.childRatingsTitle')" (exportClicked)="handleSearch($event)" [downloadBtnText]="t('stateDashboard.search.download')">
</drdp-dashboard-search>
</ng-container>
